module.exports = __webpack_public_path__ + "img/symbol_13.d0e0024d.png";